export function Pill({ label, color }: { label: string; color?: string }) {
  const style = color ? { color, backgroundColor: `${color}1f`, borderColor: `${color}4d` } : undefined;
  return <span className="mr-1 inline-block rounded-pill border border-border px-2 py-0.5 text-[11px] font-semibold" style={style}>{label}</span>;
}
export function StatusPill({ on, label }: { on: boolean; label: string }) {
  return <span className={`inline-block rounded-pill px-2 py-0.5 text-[11px] font-semibold ${on ? 'bg-success-soft text-success' : 'bg-surface-sunken text-text-secondary'}`}>{label}</span>;
}
